export default __webpack_public_path__ + "static/media/group-3-img.6137c834.png";